import {WORKER_CANCEL_LIVE} from '../constants';

export default (state = [], action) => {
    switch(action.type) {
        case WORKER_CANCEL_LIVE: return {...state, [action.payload.key]: action.payload.value};
        default: return state;
    }
}